import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaSearch } from 'react-icons/fa'
import styled, { keyframes } from 'styled-components'

export const InvoiceExtractingCard: React.FC = () => {
  const [t] = useTranslation()

  return (
    <Card>
      <IconCircle>
        <FaSearch />
      </IconCircle>
      <TextBlock>
        <Title>{t('invoicing.purchaseInvoiceDetails.analysingMessage.h3')}</Title>
        <Description>{t('invoicing.purchaseInvoiceDetails.analysingMessage.p')}</Description>
      </TextBlock>
    </Card>
  )
}

const pulse = keyframes`
  0% { opacity: 0.35; }
  50% { opacity: 1; }
  100% { opacity: 0.35; }
`

const Card = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  box-sizing: border-box;
  padding: ${({ theme }) => theme.spacing.lg}rem;
  border: 1px solid #e4e8ec;
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  background: ${({ theme }) => theme.colors.neutralWhite};
`

const IconCircle = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: ${({ theme }) => `${theme.colors.primary}1a`};
  color: ${({ theme }) => theme.colors.primary};
  animation: ${pulse} 1.6s ease-in-out infinite;

  svg {
    width: 1rem;
    height: 1rem;
  }
`

const TextBlock = styled.div`
  min-width: 0;
`

const Title = styled.div`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.menuBg};
  font-size: ${({ theme }) => theme.fontSize.md}rem;
`

const Description = styled.div`
  margin-top: 2px;
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  color: ${({ theme }) => theme.colors.iconGray};
`
